import {
    HotelInfoKey,
    IdHotelOwnerKey,
    sidKey,
    usernameKey,
} from './userProfileContextHelpers';
import api from '../services/api';
import endpoints, { publicEndpoints } from './commonVariables/endpoints';
import { decodeUrlForm } from './encodeFormUrl';

const tokenProdKey = 'tokenProd';
export const tokenProd = localStorage.getItem(tokenProdKey);

export const tokenKey = 'TOKEN';
export const lsToken = localStorage.getItem(tokenKey);

export const webTokenKey = 'SRT';
export const webToken = localStorage.getItem(webTokenKey);

export const rolKey = 'ROL';
export const rol = localStorage.getItem(rolKey);

export const lastPageVisitedKey = 'lastPageVisited';

export const authorizedUsers = ['HOTELOWNER'];

export const logOut = () => {
    localStorage.removeItem(tokenKey);
    localStorage.removeItem(webTokenKey);
    localStorage.removeItem(rolKey);
    localStorage.removeItem(sidKey);
    localStorage.removeItem(IdHotelOwnerKey);
    localStorage.removeItem(HotelInfoKey);
    localStorage.removeItem(usernameKey);

    const lastPageVisited = localStorage.getItem(lastPageVisitedKey);
    if (lastPageVisited)
        localStorage.setItem(lastPageVisitedKey, lastPageVisited);
};

export const isAuthorizedRol = (roles: string): boolean => {
    const arrayRoles = roles.split(',');
    return arrayRoles.some(_rol => authorizedUsers.includes(_rol));
};

export const logIn = async (logInData: string): Promise<boolean> => {
    const { data } = await api.post(publicEndpoints.login, logInData);
    const { roles, sid, extendedRoles } = data;
    // estended roles string structure => EXTENDED_ROLE | ID_ENTITY , EXTENDED_ROLE | ID_ENTITY ...
    // ex:  "extendedRoles": "HotelOwner|1234,Agency|1234", => normally only hotelOwner role
    const extendedRolesArray = extendedRoles
        .split(',')
        .map((_rol: string) => _rol.split('|'));
    const ownerExtendedRole = extendedRolesArray.find(
        ([extendedRole, _idEntity]: [string, string]) => {
            return extendedRole.toLowerCase() === 'hotelowner';
        }
    );
    if (isAuthorizedRol(roles) && ownerExtendedRole) {
        const [, _idHotelOwner] = ownerExtendedRole;

        localStorage.setItem(tokenKey, data.access_token);
        localStorage.setItem(rolKey, data.roles);
        localStorage.setItem(sidKey, sid);
        localStorage.setItem(IdHotelOwnerKey, _idHotelOwner);
        localStorage.setItem(webTokenKey, data.webtoken);
        const decodedLogInData: { username?: string } =
            decodeUrlForm(logInData);
        if (decodedLogInData?.username)
            localStorage.setItem(usernameKey, decodedLogInData?.username);
        return true;
    } else {
        return false;
    }
};

export const getAreLocalStorageUserData = () => {
    const _lsToken = localStorage.getItem(tokenKey);
    const _webToken = localStorage.getItem(webTokenKey);
    const _rol = localStorage.getItem(rolKey);
    const _idHotelOwner = localStorage.getItem(IdHotelOwnerKey);
    const _idSystemUser = localStorage.getItem(sidKey);
    const _username = localStorage.getItem(usernameKey);

    return (
        _lsToken &&
        _rol &&
        _idSystemUser &&
        _idHotelOwner &&
        _webToken &&
        _username
    );
};

export const checkCredentials = async () => {
    let isValidToken = null;
    try {
        const { data } = await api.get(endpoints.checkCredentials);
        isValidToken = data.Result;
    } catch {
        isValidToken = false;
    }
    return isValidToken;
};
